import type { User } from '@clerk/backend'

export const makeFullNameFromClerkUser = (
  user: Pick<User, 'firstName' | 'lastName' | 'username'>
) => {
  if (!user.firstName && !user.lastName) return user.username ?? ''
  if (!user.lastName) return user.firstName as string
  if (!user.firstName) return user.lastName as string
  return `${user.firstName} ${user.lastName}`
}

export const makeShortNameFromClerkUser = (
  user: Pick<User, 'firstName' | 'lastName' | 'username'>
): string => {
  if (user.firstName?.trim().length) return user.firstName
  if (user.username?.trim().length) return user.username
  return user.lastName ?? ''
}
